import { Badge } from '@mui/material'
import { COLORS } from "../../../styles/variables";

type StyledBadgeProps = {
  size?: number
  colorBadge?: string
} & React.ComponentProps<typeof Badge>;

export const StyledBadge = ({ size = 15, colorBadge = COLORS.STOPLIGHT_GO_GREEN, ...props }: StyledBadgeProps) => {
  return (
    <Badge
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: colorBadge,
          color: COLORS.WHITE,
          width: "auto",
          height: `${size}px`,
          minWidth: `${size}px`,
          borderRadius: 50,
        },
      }}
      {...props}
    />
  );
};
